/**
 * Gebruik mijn huidige locatie knop in front search form
 */
export class UseLocation {
  constructor() {
    this.$target = null;
    $('.js-use-location').on('click', (e) => this.onTriggerClicked(e));
  }

  /**
     * Determines the input target and fetches the users location
     * @param e
     */
  onTriggerClicked(e) {
    e.preventDefault();
    this.$target = $($(e.currentTarget).data('target'));

    if (navigator.geolocation) {
      this.fetchPosition();
    } else {
      this.changePlaceholder('Locatie niet beschikbaar');
    }
  }

  /**
     * Use the native navigator to get the users location
     */
  fetchPosition() {
    navigator.geolocation.getCurrentPosition(
      /* istanbul ignore next */pos => this.getGoogleMapsLocation(pos),
      /* istanbul ignore next */err => this.showError(err)
    );
  }

  /**
     * Update the fields placeholder
     * @param val
     * @param clearValue
     */
  changePlaceholder(val, clearValue = true) {
    if (clearValue) {
      this.$target.val('');
    }
    this.$target.attr('placeholder', val);
  }

  /**
     * Retrieve the city using the google maps api
     * @param position
     */
  getGoogleMapsLocation(position) {
    this.changePlaceholder('Bezig met ophalen locatie...');

    const lat = position.coords.latitude;
    const lng = position.coords.longitude;
    const apiKey = 'AIzaSyAIZaFCuMp5JVs4nSQqdvyV-2MGQuHtvuo';

    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;
    $.getJSON(url, /* istanbul ignore next */ response => this.handleGoogleMapsResponse(response));
  }

  /**
     * update the reponse ore
     * @param response
     */
  handleGoogleMapsResponse(response) {
    if (response.status === 'OK') {
      let resultCity = '';
      let resultPostalCode = '';
      const addressComponents = response.results[0].address_components;

      for (let component of addressComponents) {
        if (component.types.includes('locality')) {
          resultCity = component.long_name;
        }
        if (component.types.includes('postal_code')) {
          resultPostalCode = component.long_name;
        }
        if (resultPostalCode && resultCity) {
          break;
        }
      }

      if (resultCity === '') {
        for (let component of addressComponents) {
          if (component.types.includes('administrative_area_level_2')) {
            resultCity = component.long_name;
            break;
          }
        }
      }

      let result = resultPostalCode ? `${resultPostalCode} ${resultCity}` : resultCity;
      this.$target.val(result);
    } else {
      this.showError(response.status);
    }
  }


  /**
     * Show the error in the input fields placeholder
     * @param error
     */
  showError(error) {
    switch (error.code) {
      case 1:
        this.changePlaceholder('Je hebt delen van geolocatie geblokkeerd', false);
        break;
      case 2:
        this.changePlaceholder('Locatie niet beschikbaar');
        break;
      case 3:
        this.changePlaceholder('Time out bij ophalen locatie');
        break;
      default:
        this.changePlaceholder('Onbekende fout bij ophalen locatie');
        break;
    }
  }
}

